import React from "react";

function PlayIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.506 3.50305L12.501 8.00005L4.501 12.5L4.506 3.50305ZM4.502 1.99805C3.718 1.99805 3 2.62605 3 3.50005V12.5C3 13.374 3.718 14.002 4.502 14.002C4.747 14.002 4.998 13.941 5.235 13.807L13.235 9.30705C14.254 8.73405 14.254 7.26605 13.235 6.69205L5.235 2.19305C5.01141 2.06633 4.759 1.99918 4.502 1.99805Z"
        fill="white"
      />
    </svg>
  );
}

export default PlayIcon;
